import cookie from "react-cookies";
import { fetchProfile } from "./profile";
import { fetchAccounts } from "./accounts";

import {ACCOUNTS_LIMIT} from "../helpers/accounts";

let devToken;

try {
  // Attempt to require the devToken.js file (it's not committed or available in production)
  devToken = require('./devToken').default;
 
} catch (error) {
  // If it's not available, we'll just ignore it
  devToken = null;
}




export const REQUEST_PREREQUISITES = "REQUEST_PREREQUISITES";
export const RECEIVE_PREREQUISITES = "RECEIVE_PREREQUISITES";
export const FORGET_TOKEN = "FORGET_TOKEN";

export const requestPrereqs = token => ({
  type: REQUEST_PREREQUISITES,
  token: token
});

export const receivePrereqs = json => ({
  type: RECEIVE_PREREQUISITES,
  config: json.config,
  webtoken: json.webtoken
});

export function fetchPrereqs() {
  return function (dispatch) {

    // condutionally get a token from a file called devToken.js, which is not available in production
    // if it's not there, get it from a cookie

    const webtoken = devToken || cookie.load("conductor_token");


    dispatch(requestPrereqs(webtoken));
    

    return fetch(`/prerequisite?token=${webtoken}`)
      .then(
        response => response.json(),
        error => dispatch(receivePrereqs({}))
      )
      .then(json => {
        dispatch(receivePrereqs(json));
        dispatch(fetchProfile());
        dispatch(fetchAccounts({ limit: ACCOUNTS_LIMIT  }));
        
      })
      .catch(function (error) {
        /*
        There was a warning in redux docs about use of catch().
        Basically they say don't use it because of a react bug.
        // https://github.com/facebook/react/issues/6895
        However - it seems fixed so I'm putting it back
        */
        dispatch(receivePrereqs({}));
      });
  };
}

export const forgetToken = () => ({
  type: FORGET_TOKEN
});



// WEBPACK FOOTER //
// ./src/actions/prerequisites.js